import type { TrackingEvent } from "../types";

const CAMPAIGN_TRACKED_EVENTS = new Set(["begin_checkout", "purchase"]);

/**
 * Keeps campaign attribution at the top level for existing consumers and in
 * ecommerce for GA, without changing items or coupon.
 * Subscription events are normalized to these event names before enrichment.
 */
export function attachCampaignToEcommerceEvent(
  event: TrackingEvent,
  campaignSource?: string,
): TrackingEvent {
  if (
    !campaignSource ||
    !CAMPAIGN_TRACKED_EVENTS.has(event.eventName) ||
    !event.ecommerce
  ) {
    return event;
  }

  return {
    ...event,
    campaign_source: campaignSource,
    ecommerce: {
      ...event.ecommerce,
      campaign_source: campaignSource,
    },
  };
}
